import { Text } from '../../FormControls/Text';
import { Fragment } from 'react';
import { Stack } from '../../FormControls/Stack';
import { ScreenControl } from '../ScreenControl';
// import { useCookies } from "react-cookie";
import { useDispatch, useSelector } from "react-redux";
import { jump } from "../../../../main/slices/routerSlice";
import { Button } from '../../FormControls/Button';
import { CancelOutlined, ArrowBackIos } from "@mui/icons-material";

export const Error = ({ dimensions }) => {
    const dispatch = useDispatch();
    return (
        <Fragment>
            <div style={{ padding: "0 1.5rem" }}>
                {/* SCREEN LEGENDS */}
                <div style={{alignItems: 'center', textAlign: 'center'}}>
                    <CancelOutlined sx={{ fontSize: "10em", margin: "0 0.5em", color: "#be123c" }}
                    ></CancelOutlined>
                </div>
                <Text classes={["title"]} style={{alignItems: 'center', textAlign: 'center'}}> ¡Ocurrió un error!</Text>
                
                <div style={{ marginBottom: "2rem" }}></div>
                <Text classes={["subtitle"]} style={{alignItems: 'center', textAlign: 'center'}} > La transacción no pudo ser procesada</Text>
                <Text classes={["subtitle"]} style={{alignItems: 'center', textAlign: 'center'}}> 
                    Si tienes alguna consulta, comunícate con nuestro servicio al cliente: {"\r\n"}
                    <a href="https://coincaex.com/SoporteRecibe" target="_blank" rel="noopener noreferrer">
                    Soporte
                    </a>
                </Text>
                <Button 
                    style={{
                        position: "fixed",
                        top: "1.5rem",
                    }} 
                    classes={["btnBackward", "alignBtnContent", "purpleBtn"]} 
                    onClick={() => dispatch(jump({ current: 8, direction: "backward" })) }
                >
                    <ArrowBackIos />
                </Button>
                
                <div style={{ marginBottom: "2rem" }}></div>
                {/* </Stack> */}
                <ScreenControl
                    showGoBack= {false}
                    index={{ fw: 8 }}
                    disabled={false}
                    // beforeSubmit={() => redirect()}
                ></ScreenControl>
            </div>
        </Fragment>
    )
}